const data = [
    {
        id: 0,
        image: "images/skps.svg",
        alt: "photoshop",
    },
    {
        id: 1,
        image: "images/skfigma.svg",
        alt: "figma",
    },
    {
        id: 2,
        image: "images/skxd.svg",
        alt: "xd",
    },
    {
        id: 3,
        image: "images/skhtml.svg",
        alt: "html",
    },
    {
        id: 4,
        image: "images/skcss.svg",
        alt: "css",
    },
    {
        id: 5,
        image: "images/skB.svg",
        alt: "bootstrap",
    },
    {
        id: 6,
        image: "images/skmaterialize.svg",
        alt: "materialize css",
    },
    {
        id: 7,
        image: "images/sktailwind.svg",
        alt: "tailwind css",
    },
    {
        id: 8,
        image: "images/skjavascript.svg",
        alt: "js",
    },
    {
        id: 9,
        image: "images/skjquery.svg",
        alt: "jquery",
    },
    {
        id: 18,
        image: "images/skreact.svg",
        alt: "react js",
    },
    {
        id: 10,
        image: "images/skmaterialui.svg",
        alt: "material ui",
    },
    {
        id: 11,
        image: "images/skC.svg",
        alt: "chart js",
    },
    {
        id: 12,
        image: "images/sknext.svg",
        alt: "next js",
    },
    {
        id: 13,
        image: "images/sksass.svg",
        alt: "scss",
    },
    {
        id: 14,
        image: "images/skpostman.svg",
        alt: "postman",
    },
    {
        id: 15,
        image: "images/skal.svg",
        alt: "illustrator",
    },
    {
        id: 16,
        image: "images/skfirebase.svg",
        alt: "firebase",
    },
    {
        id: 17,
        image: "images/skgithub.svg",
        alt: "github",
    },
];

export default data;
